import React from 'react';
import DeviationSidebarGrid from '../../_partials/DeviationSidebarGrid';
import TitlePlaceholder from '../../_partials/TitlePlaceholder';
import collectionsBlockStyles from './CollectionsBlock.scss';
export var CollectionBlockLoader = function (_a) {
    var parentDeviation = _a.parentDeviation, index = _a.index;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: collectionsBlockStyles['collection-header'] },
            React.createElement(TitlePlaceholder, { className: collectionsBlockStyles['by-author-title'], splitIndex: index })),
        React.createElement(DeviationSidebarGrid, { streamId: "devpage-sidebar-collections", className: collectionsBlockStyles['collection-grid'], parentDeviation: parentDeviation, deviations: [], maxRows: 1, isLoading: true })));
};
CollectionBlockLoader.displayName = 'CollectionBlockLoader';
export default CollectionBlockLoader;
//# sourceMappingURL=CollectionBlock.loader.js.map